
import React, { MouseEvent, useEffect, useState, useRef } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';

import { useWindowSize } from 'react-use';

import { currentBasicTextFilterPropsAtom, currentFormNameAtom, currentUserSessionAtom, isSaveLoadingAtom } from 'library/store';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';

import { useMutation, useQuery, useQueryClient } from 'react-query';

import { useTheme } from '@mui/material/styles';

import { MenuItem, Card, CardContent, IconButton, TextField, Dialog, DialogTitle, DialogContent, DialogActions, Checkbox, Chip, Divider, Tooltip } from "@mui/material";


import PrintIcon from "@mui/icons-material/Print";
import VisibilityIcon from '@mui/icons-material/Visibility';
import SystemUpdateAltIcon from '@mui/icons-material/SystemUpdateAlt';


import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { flexBetween, flexBetweenCenter, flexCenter, justifyCenter, typographyGroupBoxStyling } from 'themes/commonStyles';

//import { useBasicFilterSchoolYear } from 'features/setup/services/SchoolYear';
import useRegistrationService from 'features/finance/services/Billing';

import { ISchoolYear, ISchoolYearClass } from 'features/setup/models/SchoolYear';

import { defaultBasicTextFilterProps, IPagination, ITextFilterElement } from 'components/ui/BasicTextFilterForm';

import useEntityService from 'features/services/Entity';

import { Button } from '@mui/material';
import { MdCheckBox, MdCheckBoxOutlineBlank, MdOutlineChangeCircle, MdOutlineIndeterminateCheckBox } from 'react-icons/md';
import { FormDialog } from 'components/ui/FormDialog';

import useEnumerationService, { useBasicFilterEnumeration, useEnumerationItemCreateUpdate } from 'features/configuration/services/Enumeration';

import IEnumeration, {
  IEnumerationItem,
} from 'features/configuration/models/Enumeration';


import { isFalsy } from 'utility-types';
import { useNavigate, useParams } from 'react-router-dom';

import { debounce } from 'lodash';
import { IBilling, IBillingSearch } from './models/Billing';
import { Cancel, CheckCircle } from '@mui/icons-material';
import { IResult } from 'library/interface';
import { useSnackbar } from 'notistack';
import { BasicTextFilterField } from 'components/ui/BasicTextFilterField';


import useUtils from 'library/utils';




export const BatchBillingForm = () => {

  const { statusLevel, paymentLevel } = useParams<{ statusLevel: string, paymentLevel: string }>();

  const theme = useTheme();

  const { t, i18n } = useTranslation();
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const navigate = useNavigate();

  const { openEntityPrintDrawer, openEntityPrintDrawerEx, checkPrintAuthorization,
    hasEntityAuthorization, openEntityActionDrawer } = useEntityService();

  const [currentFormName, setCurrentFormName] = useRecoilState(currentFormNameAtom);
  const [isSaveLoading, setIsSaveLoading] = useRecoilState(isSaveLoadingAtom);

  const { language: lg, applicationSetup, roleEntities } = useRecoilValue(currentUserSessionAtom);
  const [schoolYearName, setSchoolYearName] = useState('');

  const { formatMoney, getStatusConfig } = useUtils();

  const [currentBasicTextFilterProps, setCurrentBasicTextFilterProps] = useRecoilState(currentBasicTextFilterPropsAtom);

  const { height, width } = useWindowSize();

  const { getBillings, batchValidateBillings,
    batchCancelPropositionBillings, } = useRegistrationService();
  //const [dashboard, setDashboard] = useState<IDashboardSchoolYear>(defaultDashboardSchoolYear);

  const { getEnumerationItemsByEnumerationCodes, getExtensionEnumerationItemsBySchoolYear, getItemName } = useEnumerationService();


  // const [openSchoolYearFilter, setOpenSchoolYearFilter] = useState(false);
  // const basicFilterSchoolYear = useBasicFilterSchoolYear(
  //   async (event: React.MouseEvent<unknown>, row: ISchoolYear) => {
  //     const { id, name } = row;

  //     setSchoolYearId(id);
  //     setSchoolYearName(name);

  //     setOpenSchoolYearFilter(false);
  //   }
  // );

  const { error, mutate: mutateBatchValidate } = useMutation<IResult<boolean>, Error, { billingIds: number[] }>(
    batchValidateBillings, {
    onSuccess: (data: IResult<boolean>) => {
      enqueueSnackbar(t('_Operation_done'), {
        variant: 'success',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 1000
      });

      setIsSaveLoading(false);
    },
    onError: (err: Error) => {
      enqueueSnackbar(error?.message, {
        variant: 'error',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
      });
      setIsSaveLoading(false);
    }
  });


  const { error: errCancelProposition, mutate: mutateBatchCancelProposition } = useMutation<IResult<boolean>, Error, { billingIds: number[] }>(
    batchCancelPropositionBillings, {
    onSuccess: (data: IResult<boolean>) => {
      enqueueSnackbar(t('_Operation_done'), {
        variant: 'success',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 1000
      });

      setIsSaveLoading(false);
    },
    onError: (err: Error) => {
      enqueueSnackbar(error?.message, {
        variant: 'error',
        anchorOrigin: { horizontal: 'center', vertical: 'top' }, autoHideDuration: 2000
      });
      setIsSaveLoading(false);
    }
  });


  // const { data: enumItems, refetch: refetchEnumerationItems } = useQuery<IEnumerationItem[]>(
  //   ['EnumerationItems', 'BatchBilling'], () => getEnumerationItemsByEnumerationCodes
  //     (['']));


  // const handleClickSelectSchoolYear = (event: any) => {
  //   setOpenSchoolYearFilter(true);
  // }

  const [filterElements, setFilterElements] = useState<ITextFilterElement[]>([

    { name: 'startDate', text: t('Start date'), dataType: 'date', value: '', dateValue: new Date() },
    { name: 'endDate', text: t('End date'), dataType: 'date', value: '', dateValue: new Date() },

    { name: 'isMyBillings', text: t('My sales / billings'), value: '', dataType: 'boolean', boolValue: false },

    { name: 'customerName', text: t('Customer'), value: '' },
    { name: 'customerPortable', text: t('Portable'), value: '' },

    { name: 'reference', text: t('Reference'), value: '' },
    { name: 'billingNumber', text: t('Billing N°'), value: '' },
    { name: 'proformaNumber', text: t('Init/Prof. N°'), value: '' },
  ]);

  const onFilterChange = (filterElements: ITextFilterElement[]) => {
    setFilterElements(filterElements);
    debouncedFilterChange(filterElements);
  }

  const refEnumItems = useRef<IEnumerationItem[]>();
  // useEffect(() => {
  //   refEnumItems.current = enumItems;

  // }, [enumItems]);

  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  // Selection handlers
  const handleSelect = (id: number) => {
    setSelectedIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleSelectAll = () => {
    setSelectedIds(bilings.map((r) => r.id));
  };

  const handleUnselectAll = () => {
    setSelectedIds([]);
  };

  const handleInvertSelection = () => {
    setSelectedIds((prev) =>
      bilings.map((r) => r.id).filter((id) => !prev.includes(id))
    );
  };


  const [bilings, setBillings] = useState<IBilling[]>([]);

  const handleNavigate2Billing = (billingId: number) => {
    navigate(`/billingCommand/${billingId}`); // Adjust path as needed
  };

  const handlePrintBilling = (billingId: number) => {
    openEntityPrintDrawer('Billing', billingId);
  };

  const handleActionRegistration = (billingId: number) => {
    openEntityActionDrawer('Billing', billingId);
  };

  const debouncedFilterChange = useRef(
    debounce(async (filterElements: ITextFilterElement[], pagination?: IPagination) => {

      const criteria : IBillingSearch = {
        statusLevel: statusLevel || '00',
        startDate: filterElements.find(fe => fe.name === 'startDate')?.dateValue ?? new Date(),
        endDate: filterElements.find(fe => fe.name === 'endDate')?.dateValue ?? new Date(),
        isMyBillings: filterElements.find(fe => fe.name === 'isMyBillings')?.boolValue ?? false,
        paymentLevel: paymentLevel || '',
        customerName: filterElements.find(fe => fe.name === 'customerName')?.value ?? '',
        customerPortable: filterElements.find(fe => fe.name === 'customerPortable')?.value ?? '',
        reference: filterElements.find(fe => fe.name === 'reference')?.value ?? '',
        billingNumber: filterElements.find(fe => fe.name === 'billingNumber')?.value ?? '',
        proformaNumber: filterElements.find(fe => fe.name === 'proformaNumber')?.value ?? '',
      };
      const arr = await getBillings(criteria, pagination);

      setBillings(arr);

    }, 100)
  ).current;

  // useEffect(() => {
  //   debouncedFilterChange(filterElements, { pageNumber: 1, pageSize: 100 } );

  //   return () => {
  //     debouncedFilterChange.cancel(); // VERY IMPORTANT
  //   };
  // }, [filterElements.map(x => `${x.value}-${x.dateValue}-${x.boolValue}`).join(':'), statusLevel, paymentLevel]);

  // useEffect(() => {
  //   async function _() {
  //     debouncedFilterChange({
  //       statusLevel: statusLevel || '00',
  //       startDate: filterElements.find(fe => fe.name === 'startDate')?.dateValue || new Date(),
  //       endDate: filterElements.find(fe => fe.name === 'endDate')?.dateValue || new Date(),
  //       isMyBillings: filterElements.find(fe => fe.name === 'isMyBillings')?.boolValue || false,
  //       paymentLevel: paymentLevel || '',
  //       customerName: filterElements.find(fe => fe.name === 'customerName')?.value || '',
  //       customerPortable: filterElements.find(fe => fe.name === 'customerPortable')?.value || '',
  //       reference: filterElements.find(fe => fe.name === 'reference')?.value || '',
  //       billingNumber: filterElements.find(fe => fe.name === 'billingNumber')?.value || '',
  //       proformaNumber: filterElements.find(fe => fe.name === 'proformaNumber')?.value || '',
  //     }, { pageNumber: 1, pageSize: 100 }

  //     );
  //   }
  //   _();
  // }, [filterElements, debouncedFilterChange]);


  useEffect(() => {
    setCurrentFormName(`${t('Billing/Sale')} :: ${t('Batch processing')}`);
    setCurrentBasicTextFilterProps(defaultBasicTextFilterProps);
    setIsSaveLoading(false);
  }, []);

  useEffect(() => {
    async function _() {

      debouncedFilterChange(filterElements, { pageNumber: 1, pageSize: 100 });
    }
    _();
  }, []);

  const printData = async (event: MouseEvent<HTMLButtonElement>) => {

    // openEntityPrintDrawerEx('SchoolYearClassDashboard', 0, [{ name: 'SchoolYearId', value: schoolYearId, dateValue: new Date() },
    // { name: 'StudyType', value: studyType, dateValue: new Date() }, { name: 'ClassOrder', value: classOrder, dateValue: new Date() },
    // { name: 'StudyLevel', value: studyLevel, dateValue: new Date() }, { name: 'StudySection', value: studySection, dateValue: new Date() },
    // { name: 'StudyLanguage', value: studyLanguage, dateValue: new Date() },
    // { name: 'StudyCycle', value: studyCycle, dateValue: new Date() }, { name: 'Gender', value: gender, dateValue: new Date() }]);
  }


  // Actions
  const handleValidate = () => {
    if (selectedIds.length === 0) return;

    mutateBatchValidate({ billingIds: selectedIds });
  };

  const handleCancel = () => {
    if (selectedIds.length === 0) return;

    mutateBatchCancelProposition({ billingIds: selectedIds });
  };

  return (
    <Box sx={{ mx: 0.1 }}>
      <Grid container rowSpacing={1} columnSpacing={3}>


        {/* ---- ACTION BAR ---- */}
        <Grid item xs={12}>
          <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
            <Stack direction="row" spacing={1}>
              <IconButton onClick={handleSelectAll} title="Select all">
                <MdCheckBox />
              </IconButton>
              <IconButton onClick={handleUnselectAll} title="Unselect all">
                <MdCheckBoxOutlineBlank />
              </IconButton>
              <IconButton onClick={handleInvertSelection} title="Invert selection">
                <MdOutlineIndeterminateCheckBox />
              </IconButton>
            </Stack>

            <Stack direction="row" spacing={1}>
              {roleEntities.some(re => re.entityName === 'Billing'
                && re.roleEntityFeatures.some(f => f.featureName === 'ValidateRegistrationHandler')) &&
                <Button
                  color="success"
                  variant="contained"
                  startIcon={<CheckCircle />}
                  disabled={selectedIds.length === 0}
                  onClick={handleValidate}
                >
                  {t('Validate')}
                </Button>}
              {roleEntities.some(re => re.entityName === 'Billing'
                && re.roleEntityFeatures.some(f => f.featureName === 'CancelRegistrationHandler')) &&
                <Button
                  color="error"
                  variant="contained"
                  startIcon={<Cancel />}
                  disabled={selectedIds.length === 0}
                  onClick={handleCancel}
                >
                  {t('Cancel')}
                </Button>}
            </Stack>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <BasicTextFilterField filterElements={filterElements} onFilterChange={onFilterChange} />
        </Grid>
        <Grid item xs={12}>
          <Box p={{ xs: 1, sm: 2 }}>
            <Grid container spacing={{ xs: 1, sm: 2 }}>
              {bilings.map(
                ({
                  id,
                  reference,
                  billingNumber,
                  customerName,
                  currencyCode,
                  amount,
                  amountPaid,
                  unpaidAmount,
                  status,
                }) => {
                  const statusConfig = getStatusConfig(status, t);

                  return (
                    <Grid key={id} item xs={12} sm={6} md={4} lg={3}>
                      <Card
                        sx={{
                          height: '100%',
                          borderRadius: 2,
                          boxShadow: { xs: 2, sm: 3 },
                          opacity: status === '80' || status === '85' ? 0.75 : 1,
                          transition: 'all 0.25s ease',
                          display: 'flex',
                          flexDirection: 'column',
                          '&:hover': {
                            transform: { sm: 'translateY(-3px)' },
                            boxShadow: { sm: 5 },
                          },
                        }}
                      >
                        <CardContent sx={{ p: { xs: 1.5, sm: 2 } }}>
                          {/* HEADER ROW: Checkbox + Reference + Status */}
                          <Box
                            display="flex"
                            alignItems="center"
                            justifyContent="space-between"
                            mb={1}
                          >
                            <Box display="flex" alignItems="center" minWidth={0} flex={1}>
                              <Checkbox
                                size="small"
                                checked={selectedIds.includes(id)}
                                onChange={() => handleSelect(id)}
                              />
                              <Typography
                                variant="subtitle2"
                                fontWeight={700}
                                noWrap
                                sx={{ ml: 1, overflow: 'hidden', textOverflow: 'ellipsis', minWidth: 0 }}
                                title={reference}
                              >
                                {reference}
                              </Typography>
                            </Box>

                            <Chip
                              size="small"
                              label={statusConfig.label}
                              color={statusConfig.color}
                              sx={{ fontWeight: 600, ml: 1, flexShrink: 0 }}
                            />
                          </Box>

                          {/* CUSTOMER + BILLING NUMBER */}
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            noWrap
                            title={customerName}
                            sx={{ display: 'block', mb: 0.5 }}
                          >
                            {customerName} {billingNumber && `#${billingNumber}`}
                          </Typography>

                          {/* AMOUNTS AS CHIPS */}
                          <Stack
                            direction="row"
                            spacing={0.5}
                            flexWrap="wrap"
                            mb={1.5}
                          >
                            <Tooltip
                              title={`${t('Unpaid')}: ${formatMoney(
                                lg,
                                unpaidAmount,
                                currencyCode
                              )}`}
                              arrow
                            >
                              <Chip
                                label={`${t('Amount')}: ${formatMoney(
                                  lg,
                                  amount,
                                  currencyCode
                                )}`}
                                color="primary"
                                size="small"
                                sx={{ fontWeight: 600 }}
                              />
                            </Tooltip>

                            <Tooltip
                              title={`${t('Unpaid')}: ${formatMoney(
                                lg,
                                unpaidAmount,
                                currencyCode
                              )}`}
                              arrow
                            >
                              <Chip
                                label={`${t('Paid')}: ${formatMoney(
                                  lg,
                                  amountPaid,
                                  currencyCode
                                )}`}
                                color="success"
                                size="small"
                                sx={{ fontWeight: 600 }}
                              />
                            </Tooltip>
                          </Stack>

                          {/* ACTIONS */}
                          <Box mt="auto">
                            <Divider sx={{ mb: 0.8 }} />
                            <Stack
                              direction="row"
                              justifyContent="flex-end"
                              spacing={0.3}
                            >
                              <IconButton
                                size="small"
                                color="primary"
                                disabled={!hasEntityAuthorization('Billing')}
                                onClick={() => handleNavigate2Billing(id)}
                              >
                                <VisibilityIcon fontSize="small" />
                              </IconButton>

                              <IconButton
                                size="small"
                                color="secondary"
                                disabled={!checkPrintAuthorization('Billing')}
                                onClick={() => handlePrintBilling(id)}
                              >
                                <PrintIcon fontSize="small" />
                              </IconButton>

                              <IconButton
                                size="small"
                                disabled={
                                  !hasEntityAuthorization('Billing') ||
                                  status === '80' ||
                                  status === '85'
                                }
                                onClick={() => handleActionRegistration(id)}
                              >
                                <SystemUpdateAltIcon fontSize="small" />
                              </IconButton>
                            </Stack>
                          </Box>
                        </CardContent>
                      </Card>
                    </Grid>
                  );
                }
              )}
            </Grid>
          </Box>
        </Grid>



      </Grid>

    </Box>
  )
}
